import Modal from './modal.js';

namespace('IO.Views', function (exports) {
  var InformationModal = Modal.extend({
    dom: {
      INFORMATION_MESSAGE: '#information-message',
    },

    show: function (message, callback, position) {
      var self = this,
        centerPosition;

      $(this.dom.INFORMATION_MESSAGE).html(message);
      this.opts.callback = callback;

      centerPosition = {
        top: $(document).scrollTop() + $(window).height() / 4,
        left: ($(window).width() - this.$el.width()) / 2,
      };

      this._showBackground();
      this._setPosition(position || centerPosition);
      this.waiting(false);

      self.$el.css({ display: 'block' });
      self.$el.addClass('modal-fade-in');

      return this;
    },

    close: function () {
      this.$el.removeClass('modal-fade-in');
      this.$background.removeClass('modal-fade-in');

      this.trigger('modalClosed');
      this._afterClose();

      return this;
    },

    removeListener: function () {
      this.$el.off('click');
    },

    _afterClose: function () {
      $('.modal-background').css({ zIndex: 100 });
      if (this.opts.callback !== undefined) {
        this.opts.callback();
      }
    },
  });

  exports.InformationModal = InformationModal;
});
